import React from "react";
import { Handle } from 'react-flow-renderer';
import { handlesColors } from "./";

export const HandleOutputYellow = ({isConnectable = true, onConnect, top = "unset", bottom = "unset", height = "33.2%", borderRadius = "0px 0px 0px 0px"}) => {
  return (
    <Handle
      type="source"
      position="right"
      id="A"
      style={{  backgroundColor: handlesColors.A, transform: "translateY(0%)", top, bottom, borderRadius, height, border: "0px solid white", width: "10px", right: "-10px"  }}
      isConnectable={isConnectable}
      onConnect={onConnect}
    />
  );
}
